import { tns } from "tiny-slider/src/tiny-slider";
export default class FullWidthSliderBlock {
    constructor(block) {
        this.sliderBlock = block;
        this.sliderContainer = this.sliderBlock.querySelector('.products-hero-slider-wrapper');
        if (this.sliderContainer && this.sliderContainer.childElementCount >= 2) {
            // If 2 or more images - set slider active
            this.sliderControlsWrapper = this.sliderBlock.querySelector('.products-hero-slider-controls');
            this.init();
        }
    }
    init() {
        const slider = tns({
            container: this.sliderContainer,
            items: 1,
            slideBy: 1,
            loop: true,
            autoplay: false,
            controls: true,
            nav: true,
            navPosition: 'bottom',
            mouseDrag: true,
            swipeAngle: false,
            lazyload: true,
            speed: 400,
            // @ts-ignore
            prevButton: this.sliderControlsWrapper.querySelector('.previous-slide'),
            // @ts-ignore
            nextButton: this.sliderControlsWrapper.querySelector('.next-slide'),
            responsive: {},
        });
    }
}
const fullWidthSliderBlocks = document.querySelectorAll('[data-products-hero-slider-block]');
fullWidthSliderBlocks.forEach((block) => new FullWidthSliderBlock(block));
